(() => {
  if (window.ucpPdpInitialized) return;
  window.ucpPdpInitialized = true;
  let sequence = 0;
  let controller;
  let busy = false;
  let watchdog;
  const region = (root, name) => root.querySelector(`[data-ucp-region="${name}"]`);
  const setBusy = (value) => {
    busy = value;
    document.querySelectorAll('[data-ucp-region]').forEach(el => el.setAttribute('aria-busy', String(value)));
    document.querySelectorAll('.ucp-actions [data-pdp-quote-open]').forEach(el => el.setAttribute('aria-disabled', String(value)));
    document.querySelectorAll('.ucp-actions [data-quote-submit], .ucp-sticky-trigger').forEach(el => { el.disabled = value; });
  };
  document.addEventListener('click', event => {
    if (busy && event.target.closest('.ucp-actions [data-pdp-quote-open], .ucp-sticky-trigger, .ucp-actions [data-quote-submit]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', event => {
    if (busy && event.target.closest('.ucp-actions')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('.ucp-sticky-trigger')) return;
    document.querySelector('.ucp-actions [data-pdp-quote-open]')?.click();
  });
  const update = async ({ data }) => {
    if (!document.body.classList.contains('ucp-pdp-enabled')) return;
    const main = document.querySelector('.ucp-main');
    if (!main || String(data.sectionId) !== main.dataset.section) return;
    const variant = data.variant;
    if (!variant) return;
    clearTimeout(watchdog);
    document.querySelectorAll('[data-current-variant-id]').forEach(el => { el.value = variant.id; });
    document.querySelectorAll('[data-current-sku]').forEach(el => { el.value = variant.sku || ''; });
    const current = ++sequence;
    controller?.abort();
    controller = new AbortController();
    const target = new URL(window.location.href);
    target.searchParams.set('variant', variant.id);
    const ids = Array.from(document.querySelectorAll('[data-ucp-section]')).map(el => el.dataset.ucpSection);
    const request = new URL(target);
    request.searchParams.set('sections', ids.join(','));
    setBusy(true);
    const requestTimeout = setTimeout(() => {
      if (current === sequence) { controller.abort(); window.location.assign(target.href); }
    }, 15000);
    try {
      const response = await fetch(request, { signal: controller.signal });
      if (!response.ok) throw new Error('PDP section request failed');
      const sections = await response.json();
      const parser = new DOMParser();
      const replacements = [];
      const hero = region(data.html, 'hero');
      if (!hero || hero.dataset.variantId !== String(variant.id)) throw new Error('PDP variant mismatch');
      replacements.push(['hero', hero]);
      for (const id of ids) {
        if (typeof sections[id] !== 'string') throw new Error('Missing PDP section');
        const source = parser.parseFromString(sections[id], 'text/html');
        const next = source.querySelector('[data-ucp-region]');
        if (!next || next.dataset.variantId !== String(variant.id)) throw new Error('PDP section variant mismatch');
        replacements.push([next.dataset.ucpRegion, next]);
      }
      const schemaNode = hero.querySelector('[data-ucp-product-schema]');
      if (!schemaNode) throw new Error('Missing Product structured data');
      const productSchema = JSON.parse(schemaNode.textContent);
      if (productSchema['@type'] !== 'Product' || (productSchema.sku || '') !== (variant.sku || '')) throw new Error('Product structured data mismatch');
      const nextName = hero.querySelector('h1')?.textContent.trim();
      if (!nextName || productSchema.name !== nextName) throw new Error('Product name mismatch');
      const breadcrumbNode = document.querySelector('[data-ucp-breadcrumb-schema]');
      const breadcrumbSchema = breadcrumbNode ? JSON.parse(breadcrumbNode.textContent) : null;
      if (breadcrumbSchema) breadcrumbSchema.itemListElement.at(-1).name = nextName;
      if (current !== sequence) return;
      for (const [name, next] of replacements) {
        const previous = region(document, name);
        const open = Array.from(previous.querySelectorAll('details')).map(el => el.open);
        previous.replaceWith(next);
        next.querySelectorAll('details').forEach((el, index) => { el.open = open[index] || false; });
      }
      document.querySelectorAll('[data-current-variant-id]').forEach(el => { el.value = variant.id; });
      document.querySelectorAll('[data-current-sku]').forEach(el => { el.value = variant.sku || ''; });
      document.querySelectorAll('[data-ucp-breadcrumb-product]').forEach(el => { el.textContent = nextName; });
      if (breadcrumbNode) breadcrumbNode.textContent = JSON.stringify(breadcrumbSchema).replaceAll('<', '\\u003c');
      document.querySelectorAll('.ucp-actions [data-pdp-quote-open]').forEach(el => {
        const url = new URL(el.href);
        url.searchParams.set('sku', variant.sku || '');
        el.href = url.href;
      });
    } catch (error) {
      if (error.name !== 'AbortError' && current === sequence) window.location.assign(target.href);
    } finally {
      clearTimeout(requestTimeout);
      if (current === sequence) setBusy(false);
    }
  };
  const init = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({data}) => {
        const main = document.querySelector('.ucp-main');
        if (!main?.contains(data.event.target)) return;
        ++sequence;
        controller?.abort();
        clearTimeout(watchdog);
        setBusy(true);
        const target = new URL(window.location.href);
        target.searchParams.delete('variant');
        target.searchParams.set('option_values', data.selectedOptionValues.join(','));
        watchdog = setTimeout(() => window.location.assign(target.href), 15000);
      });
      subscribe(PUB_SUB_EVENTS.variantChange, update);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

